/**
 * Delay the passed function for delays milliseconds to debounce user input
 * @param {function} fn - The function to trigger after the timeout is complete
 * @param {number} delay - The length of time to wait in milliseconds
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const debounce = <T extends (...args: any[]) => any>(fn: T, delay: number) => {
  let timer: ReturnType<typeof setTimeout>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

export default debounce;
